import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

export default function Shell() {
  return (
    <div className="flex h-screen w-screen bg-[#030303] text-[#f3f4f6]">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
